import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { Col } from 'react-flexbox-grid';

import { isEqual, compact, map, isUndefined, find, keys, startsWith, isEmpty, flowRight, includes, get } from 'lodash';
import { Paper, Subheader, RaisedButton, CircularProgress } from 'material-ui';

import { fromNow } from 'utils/dateTools';
import styles from 'styles/Appraisal';
import Loading from 'components/Loading';
import QAElement from 'components/QAElement';
import Alert from 'components/Alert';
import PanelMessage from 'components/panels/PanelMessage';
import {
  fetchAppraisalByIdIfNeeded,
  saveAppraisal,
  submitAppraisal,
} from 'actions/Appraisal';
import answersToFormState from './utils/answersToFormState';
import validate from './utils/validateAppraisal';
import getAppraisalTitle from './utils/getAppraisalTitle';

const saveToStorage = (data, id) => {
  if (!id) { return; }
  const appraisalsString = localStorage.appraisals || '{}';
  const appraisals = JSON.parse(appraisalsString);
  localStorage.appraisals = JSON.stringify({
    ...appraisals, //                         h   m    s    ms
    [id]: { ...data, expires: Date.now() + (8 * 60 * 60 * 1000) },
  });
};

class Appraisal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { alertOpen: false };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    this.props.router.setRouteLeaveHook(this.props.route, this.willLeave);
    const id = this.props.router.params.appraisalId;
    dispatch(fetchAppraisalByIdIfNeeded(id));
  }

  componentWillReceiveProps(props) {
    const { submitSucceeded, pristine } = props;
    if (!pristine && !submitSucceeded) {
      window.onbeforeunload = () => 'Áður en þú yfirgefur síðuna vertu viss um að öll svör séu vistuð.';
    } else {
      window.onbeforeunload = undefined;
    }
  }

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  /* eslint react/no-find-dom-node: 0 */
  getAnswerDom = () => btoa(document.getElementById('fmat').outerHTML);

  unlockFocus() {
    return () => this.lockFocus();
  }

  lockFocus() {
    return () => this.unlockFocus();
  }

  willLeave = () => {
    const { submitSucceeded, pristine } = this.props;
    if (!pristine && !submitSucceeded) {
      return 'Áður en þú yfirgefur síðuna vertu viss um að öll svör séu vistuð.';
    }
    return true;
  }

  /*
      TODO: questions
        * Do we want the Employee to be able to see his answers after submitting?
        * How are we usign the final answers?
      TODO: isFinal is still messed, need to look at both due dates.
  */

  // TODO: When saving attachments need to go through all files in file list and save to that person.
  // Create special util to implement this functionality so it can be used later.

  /* BUG?NOTE: maybe nota good idea to include the input type in the field name
  it may cause problems when trying to fill the form with answers */
  /* TODO: Move this logic to action file */
  createAnswers = (data) => {
    /* NOTE:
        CHECKBOX
          * get QAAnswerValue from redux form value
          * get QAAnswerText from redux form name last group
        NOTE: ATTACHMENT questions put on hold!
        ATTACHMENT
          * on load of file send to repo
          * QAAnswerText is the file name
          * QAAnswerValue is the GUID of the file returned from repo
        TEXT_FIELDS
          * QAAnswerValue and QAAnswerText are set to the rf value
        DATE
          * set QAAnswerText to human version
          * set QAAnswerValue to datetime stamp
        RADIO AND SCALE
          * set QAAnswerText to the option label
          * set QAAnswerValue to QAInputOptionID or HrQualificationScaleEntryID
    */

    /* Find the ID of the Appraisal from the router */
    const id = this.props.router.params.appraisalId;

    /* Extract the Appraisal information from props/state */
    const appraisal = this.props.appraisalsById[id];

    const answers = this.props.appraisalAnswers[id];

    const stateAnswers = answers.employeeAnswers.QAAnswers;
    const RootAnswerID = answers.employeeAnswers.RootAnswerID;

    const QAElements = appraisal.PMForm.QAElements;

    /* Map through all the fields submited through the Redux form */
    const ansrs = map(keys(data), (key) => {
      if (startsWith(key, 'COMMENT') || key === 'expires') { return null; }
      const QAAnswerValue = data[key];
      /* Split the key into its components
      example: '345-34045'
      becomes ['345', '34045'] */
      const qkeys = key.split`-`;

      /* We use the Redux field names to identify information about the elements */
      const QAInputAnswerType = Number(qkeys[0]);
      const QAElementID = Number(qkeys[1]);
      const QAInputOptionLabel = qkeys[2];

      /* QAElement information */
      const {
        QAInput, Order, Level, QAElementParentID, AllowComment,
      } = find(QAElements, ['QAElementID', QAElementID]);

      const option = QAInputAnswerType === 6 ?
        find(QAInput.HrQualificationScaleEntries, ['HrQualificationScaleEntryID', QAAnswerValue]) :
        find(QAInput.QAInputOptions, ['QAInputOptionID', QAAnswerValue]);

      const checkBoxText = atob(QAInputOptionLabel || '');
      const optionText = option ? option.HrQualificationScaleEntryName || option.QAInputOptionLabel : '';
      const QAAnswerText = checkBoxText || optionText || QAAnswerValue;
      let QAAnswerComment = null;

      if (AllowComment) {
        QAAnswerComment = data[`COMMENT-${QAInputAnswerType}-${QAElementID}`];
      }

      /* If the Element is higher than 2 the Element is inside a group, then
      we have to set the correct QAAnswerParentID. */
      const QAAnswerParentID = Level <= 2 ? RootAnswerID : find(stateAnswers, ['QAElementID', QAElementParentID]).QAAnswerID;

      let existing;
      let existingValue;
      let existingComment;
      let existingID;
      const existingAnswers = stateAnswers.filter(ans => ans.QAElementID === QAElementID);
      // Check existingAnswers to see if we are adding a new answer or updating one.
      if (existingAnswers.length) {
        /* If we have a checkbox question we have to see if
         this option alread has an answer */
        if (QAInputAnswerType === 3) {
          existing = find(existingAnswers, ['QAAnswerText', atob(QAInputOptionLabel)]);
        } else {
          existing = existingAnswers[0];
        }
        existingValue = existing && existing.QAAnswerValue;
        existingID = existing && existing.QAAnswerID;
        existingComment = existing && existing.QAAnswerComment;
      }

      if (isEqual(existingValue, QAAnswerValue) && isEqual(existingComment, QAAnswerComment)) {
        return undefined;
      }

      const def = {
        QAAnswerParentID,
        QAElementID,
        QAAnswerValue,
        QAAnswerText,
        QAAnswerComment,
        QAAnswerOrder: Order,
        RootAnswerID,
      };

      if (existingID) {
        return { QAAnswerID: existingID, ...def };
      }

      return def;
    });

    return compact(ansrs);
  }

  handleSubmit = (data) => {
    const error = validate(data, this.props);
    if (!isEmpty(error)) {
      this.setState({ alertOpen: false });
      throw new SubmissionError(error);
    } else {
      /* Find the ID of the Appraisal from the router */
      const id = this.props.router.params.appraisalId;
      saveToStorage(data, id);
      return this.props.dispatch(submitAppraisal(this.createAnswers(data), id));
    }
  }

  handleSave = (data) => {
    const id = this.props.router.params.appraisalId;
    saveToStorage(data, id);
    return this.props.dispatch(saveAppraisal(this.createAnswers(data), id));
  }

  handleNav = () => {
    this.context.router.push('/appraisals');
  }

  render() {
    const {
      errorMessage,
      detailIDs,
      loadingById,
      appraisalsById,
      handleSubmit,
      isSubmitting,
      isSaving,
      invalid,
      submitFailed,
      router,
      appraisalAnswers,
      valuesByKey,
    } = this.props;

    const appraisalTitle = getAppraisalTitle(valuesByKey);

    if (errorMessage) {
      return (
        <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2}>
          <PanelMessage
            type="error"
            iconName="error"
            message={get(errorMessage, 'message') || <FormattedMessage id="appraisal.error" />}
          />
        </Col>
      );
    }

    const id = router.params.appraisalId;

    if (isUndefined(loadingById[id]) || loadingById[id]) {
      return <Loading />;
    }

    const {
      EmployeeDetailID,
      EmployeeDueDate,
      EmployeeName,
      EmployeeStatus,
      FinalAppraisalDate,
      FinalStatus,
      ManagerDueDate,
      ManagerName,
      ManagerStatus,
      PMForm,
      PMFormTitle,
    } = appraisalsById[id];
    const { alertOpen } = this.state;
    const isEmployee = includes(detailIDs, EmployeeDetailID);
    const manDue = new Date(ManagerDueDate);
    manDue.setHours(23, 59, 59);
    const empDue = new Date(EmployeeDueDate);
    empDue.setHours(23, 59, 59);
    const finDue = new Date(FinalAppraisalDate);
    finDue.setHours(23, 59, 59);
    const dueDate = empDue;
    const qaElements = PMForm.QAElements;
    // const lock = isEmployee && ((dueDate.getTime() < Date.now()) || EmployeeStatus === 2);
    const showAnswers =
      (ManagerStatus === 2 && EmployeeStatus === 2) ||
      (ManagerStatus === 2 && (empDue.getTime() < Date.now())) ||
      ((empDue.getTime() < Date.now()) && (empDue.getTime() < Date.now())) ||
      (finDue.getTime() < Date.now());
    const showOnlyEmployeeAnswers = EmployeeStatus === 2 && (ManagerStatus !== 2 || FinalStatus !== 2);
    const isReview = (FinalStatus === 2) || (finDue.getTime() < Date.now());

    const { finalAnswers, employeeAnswers, managerAnswers } = appraisalAnswers[id];

    if (!isEmployee) {
      return (
        <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2}>
          <PanelMessage
            type="warning"
            iconName="warning"
            message={<FormattedMessage id="appraisal.error.mine" />}
          />
        </Col>
      );
    }

    // if (lock && !isReview) {
    //   return (
    //     <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2}>
    //       <PanelMessage
    //         type="info"
    //         iconName="info"
    //         action={() => router.replace('/appraisals')}
    //         actionLabel="Til baka"
    //         message={<FormattedMessage id="appraisal.error.closed" />}
    //       />
    //     </Col>
    //   );
    // }

    return (
      <Col xs={12} md={10} mdOffset={1} style={{ paddingBottom: 16 }} id="fmat">
        <Subheader onClick={this.handleNav} style={styles.subheader}>
          <FormattedMessage id={appraisalTitle} />
        </Subheader>
        <Paper style={{ marginBottom: 16 }}>
          {/* IDEA: Show progress of questions answered */}
          <div style={styles.root}>
            <span style={styles.header}>{PMFormTitle}</span>
            <div style={styles.info}>
              <div style={styles.infoItem}>
                <span style={styles.infoMessage}>{EmployeeName}</span>
                <span style={styles.label}><FormattedMessage id="appraisal.employee" /></span>
              </div>
              <div style={styles.infoItem}>
                <span style={styles.infoMessage}>{ManagerName}</span>
                <span style={styles.label}><FormattedMessage id="appraisal.manager" /></span>
              </div>
              <div style={styles.infoItem}>
                {dueDate.getTime() < Date.now() ?
                  <span style={styles.errorText}><FormattedMessage id="appraisal.expired" /></span> :
                  <span style={styles.infoMessage}>{fromNow(dueDate)}</span>
                }
                <span style={styles.label}><FormattedMessage id="appraisal.timeToFinish" /></span>
              </div>
            </div>
          </div>
          <Alert
            open={alertOpen}
            onOk={handleSubmit(this.handleSubmit)}
            onCancel={() => this.setState({ alertOpen: false })}
            text={<FormattedMessage id="appraisal.alert.submit" />}
          />
        </Paper>
        <form>
          {qaElements.map(e =>
          (<QAElement
            showAnswers={showAnswers}
            showOnlyEmployeeAnswers={showOnlyEmployeeAnswers}
            noInput={isReview || showOnlyEmployeeAnswers}
            employeeAnswers={employeeAnswers || showOnlyEmployeeAnswers ? employeeAnswers.QAAnswers : []}
            managerAnswers={managerAnswers ? managerAnswers.QAAnswers : []}
            finalAnswers={finalAnswers ? finalAnswers.QAAnswers : []}
            key={e.QAElementID}
            {...e}
          />))}
          {(submitFailed || invalid) &&
            <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2}>
              <PanelMessage iconName="error" type="error" message={<FormattedMessage id="appraisal.error.required" />} />
            </Col>
          }
          {!isReview && !showOnlyEmployeeAnswers &&
            <div style={styles.actions}>
              <RaisedButton
                style={styles.action}
                onClick={handleSubmit(this.handleSave)}
                label={<FormattedMessage id="appraisal.save" />}
                disabled={invalid || isSubmitting || isSaving}
                icon={isSaving && !isSubmitting && <CircularProgress size={22} />}
              />
              <RaisedButton
                style={styles.action}
                primary
                onClick={() => this.setState({ alertOpen: true })} // handleSubmit(this.handleSubmit)}
                label={<FormattedMessage id="send" />}
                disabled={invalid || isSubmitting || isSaving}
                icon={isSubmitting && <CircularProgress size={22} />}
              />
            </div>
          }
        </form>
      </Col>
    );
  }
}

Appraisal.propTypes = {
  appraisalAnswers: PropTypes.object,
  appraisalsById: PropTypes.object,
  detailIDs: PropTypes.array,
  dispatch: PropTypes.func,
  EmployeeMasterID: PropTypes.number,
  errorMessage: PropTypes.node,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  isSaving: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  loadingById: PropTypes.object,
  pristine: PropTypes.bool,
  route: PropTypes.object,
  router: PropTypes.object,
  submitFailed: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
  valuesByKey: PropTypes.object,
};

Appraisal.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => {
  const formState = state.form;
  if (formState.appraisal && !isEmpty(formState.appraisal.values)) {
    saveToStorage(formState.appraisal.values, props.router.params.appraisalId);
  }
  return {
    ...state.Appraisal,
    detailIDs: state.loginReducer.user.detailIDs,
    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
    initialValues: answersToFormState(state, props),
    errorMessage: (state.Appraisal.error && state.Appraisal.error.Message) || state.Appraisal.error,
    valuesByKey: state.WebValuesReducer.valuesByKey,
  };
};

export default flowRight(
  connect(mapStateToProps),
  reduxForm({
    form: 'appraisal',
    warn: validate,
  }),
)(Appraisal);



// WEBPACK FOOTER //
// ./src/containers/Appraisal.js